import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-gray-900 text-white">
      <div className="flex-grow p-8 max-w-4xl mx-auto w-full">
        <h1 className="text-3xl font-bold mb-4">Términos y Condiciones</h1>
        <p className="text-gray-300 mb-4">
          Bienvenido a PixArtPlay (en adelante, “el Sitio”). Al acceder y utilizar este sitio web, aceptas cumplir los presentes Términos y Condiciones.
        </p>

        <h2 className="text-2xl font-semibold mb-3">Aceptación de los Términos</h2>
        <p className="text-gray-300 mb-4">
          Al acceder y utilizar este sitio web, aceptas estar sujeto a estos Términos y Condiciones, así como a nuestra Política de Privacidad. Si no estás de acuerdo con alguna parte de los términos, no debes utilizar nuestro sitio.
        </p>
        <h2 className="text-2xl font-semibold mb-3">Uso del Servicio</h2>
        <p className="text-gray-300 mb-4">
     
        El Sitio ofrece una plataforma digital con fines interactivos y/o entretenimiento. El usuario se compromete a utilizar el Sitio de forma responsable, lícita y conforme a la normativa vigente en Colombia.
       </p>

      <p>Queda prohibido:</p>
      <ul>
        <li>Utilizar el Sitio con fines ilegales o no autorizados</li>
        <li>Intentar afectar el funcionamiento, seguridad o disponibilidad del Sitio</li>
        <li>Usar el contenido del Sitio sin autorización cuando aplique
		
		
		</li>
      </ul>
			 	  
		  
        <h2 className="text-2xl font-semibold mb-3">Propiedad Intelectual</h2>
        <p className="text-300 mb-4">
          Todos los contenidos del Sitio (textos, imágenes, diseños, logotipos, funcionalidades y software), es propiedad de PixArtPlay y sus licenciantes(titulares) y está protegido por las leyes de propiedad intelectual.
        </p>
        <h2 className="text-2xl font-semibold mb-3">Limitación de Responsabilidad</h2>
        <p className="text-gray-300 mb-4">
          El sitio se proporciona "tal cual". No garantizamos que el servicio será ininterrumpido y/o sin errores. No seremos responsables de ningún daño directo, indirecto, incidental, consecuente o punitivo que surja del uso o la imposibilidad de usar el sitio.
        </p>
		
		<h2 className="text-2xl font-semibold mb-3">Registro y acceso</h2>
        <p className="text-gray-300 mb-4">
		  Algunas funcionalidades pueden requerir autenticación. El usuario es responsable de la veracidad de la información suministrada y del uso adecuado de su cuenta. El Sitio se reserva el derecho de suspender o cancelar cuentas que incumplan estos Términos.
        </p>
		
		<h2 className="text-2xl font-semibold mb-3">Enlaces a terceros</h2>
        <p className="text-gray-300 mb-4">
		  El Sitio puede contener enlaces a sitios web de terceros. No tenemos control sobre su contenido ni asumimos responsabilidad por sus políticas o prácticas
        </p>

		<h2 className="text-2xl font-semibold mb-3">Protección de datos personales</h2>
        <p className="text-gray-300 mb-4">
		  El tratamiento de los datos personales se rige por nuestra Política de Privacidad disponible en el Sitio. El uso del Sitio implica la aceptación de dicha política.
     	</p>

		<h2 className="text-2xl font-semibold mb-3">Contacto</h2>
        <p className="text-gray-300 mb-4">
		  Para cualquier consulta relacionada con estos Términos y Condiciones, puedes contactarnos en: contacto@pixartplay.com     	
		</p>



      </div>
    </div>
  );
};

export default Terms;
